import React, {
  useEffect,
  useState,
} from "react";

import { useAppSelector } from "../../../app/hooks";

import LegalTechnicalAnalysisHeader from "./LegalTechnicalAnalysisHeader";
import ChargesSection from "./ChargeSection";

import { useParams } from "react-router-dom";
import { fetchAssets } from "../Logic/assetsThunk";
import { useAppDispatch } from "../../../app/store";
import { fetchCharges } from "../Logic/chargesThunk";
import { selectAssetsStatus } from "../Logic/assetsSlice";
import { selectChargesStatus } from "../Logic/chargesSlice";
import { CustomLoadingSpinner } from "../../../components/ui/spinners/LoadingSpinner";
import { fetchFormConfigs } from "../Logic/formConfigsThunk";
import { fetchPTVerifications } from "../Logic/physicalTechnicalVerificationThunk";
import VerificationContainer from "./VerificationContainer";
import { fetchLegalVerifications } from "../Logic/legalVerificationThunk";

const LegalTechnicalAnalysisContent: React.FC =
  () => {
  const { id: caseId } = useParams<{ id: string }>();

    const assetsStatus =useAppSelector(selectAssetsStatus);
    const chargesStatus =useAppSelector(selectChargesStatus);

    const isLoading =assetsStatus === "loading" || chargesStatus === "loading";

    const [selectedLoanReferenceId,setSelectedLoanReferenceId] = useState<string>();

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!caseId) {
      return;
    }

    dispatch(fetchAssets(caseId));
    dispatch(fetchCharges(caseId));
    dispatch(fetchFormConfigs());
    dispatch(fetchPTVerifications(caseId));
    dispatch(fetchLegalVerifications(caseId));
  }, [caseId, dispatch]);

    const handleLoanSelectionChange = (
      loanReferenceId: string,
    ) => {
      setSelectedLoanReferenceId(
        loanReferenceId,
      );
  };

  if (isLoading) {
    return (
      <div className="p-3">
        <CustomLoadingSpinner
          title="Loading legal & technical analysis"
          subtitle="Fetching assets and charges..."
          minHeight="min-h-[350px]"
        />
      </div>  
    );
  }

  return (
    <div
      className="
        flex flex-col gap-4
        rounded-b-[14px]
        bg-white
        pb-4
      "
    >
      <LegalTechnicalAnalysisHeader
        selectedLoanReferenceId={selectedLoanReferenceId}
        onLoanSelectionChange={handleLoanSelectionChange}
      />

      <div className="px-4">
        {selectedLoanReferenceId && (
          <div className="flex flex-col gap-6">
            <ChargesSection
              loanReferenceId={selectedLoanReferenceId}
            /> 

            <VerificationContainer
              loanReferenceId={selectedLoanReferenceId}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default LegalTechnicalAnalysisContent;